import { WheelsDirection } from './wheels-direction';
import { WheelsVehicleTypeId } from './wheels-vehicle';
import { WheelsZoneName } from './wheels-zone';

export interface WheelsFilters {
  address: string;
  city: string;
  
  origin: string;
  destination: string;
  direction: WheelsDirection;
  zone: WheelsZoneName;
  zoneDisplay: string;

  exitTime: string;
  exitDate: string;
  vehicleType: WheelsVehicleTypeId;
  zipCode: string;
}

export const DEFAULT_WHEELS_FILTERS: WheelsFilters = {
  address: '',
  city: '',
  
  origin: '',
  destination: '',
  direction: WheelsDirection.FromCBX,
  zone: '',
  zoneDisplay: '',

  exitDate: '',
  exitTime: '',
  vehicleType: '',
  zipCode: '',
};

export interface WheelsTimeFilters extends Pick<WheelsFilters, 'exitDate' | 'exitTime'> {}

export const DEFAULT_WHEELS_TIME_FILTERS: WheelsTimeFilters = {
  exitDate: '',
  exitTime: '',
};

export const getDefaultWheelsFiltersWithTimeFilled = (timeFilters: WheelsTimeFilters) => {
  return { ...DEFAULT_WHEELS_FILTERS, ...timeFilters };
};
